import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", { class: "q-ma-none" }, "Skapa avställning", -1)
const _hoisted_2 = {
  class: "row q-py-xs q-px-sm text-white bg-red text-caption",
  style: {"border-radius":"2px"}
}
const _hoisted_3 = { class: "col-11" }
const _hoisted_4 = {
  key: 0,
  class: "text-negative text-caption text-weight-bold row items-center col q-mr-sm"
}
const _hoisted_5 = {
  key: 1,
  class: "col"
}
const _hoisted_6 = { class: "row items-center q-gutter-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_VehicleWithdrawalForm = _resolveComponent("VehicleWithdrawalForm")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_VehicleWithdrawalConfirmBackInTimeModal = _resolveComponent("VehicleWithdrawalConfirmBackInTimeModal")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    "model-value": true,
    onHide: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        square: "",
        style: {"width":"500px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_form, {
            ref: "formRef",
            onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"]),
            autocomplete: "off",
            greedy: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_q_separator),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_VehicleWithdrawalForm, _mergeProps({ ref: "vehicleFormRef" }, _ctx.$props, {
                    modelValue: _ctx.model,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
                    "form-type": "create",
                    onDisable: _cache[1] || (_cache[1] = (val) => (_ctx.disableForm = val)),
                    onWarning: _cache[2] || (_cache[2] = (msg) => (_ctx.vehicleWarningText = msg))
                  }), null, 16, ["modelValue"])
                ]),
                _: 1
              }),
              (_ctx.errorMessage)
                ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_q_icon, { name: "mdi-alert-circle-outline q-mr-sm" })
                        ]),
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1)
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_q_separator),
              _createVNode(_component_q_card_actions, { class: "row items-center justify-between q-px-md q-py-sm" }, {
                default: _withCtx(() => [
                  (_ctx.vehicleWarningText)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_q_icon, {
                          name: "mdi-alert-circle-outline",
                          class: "q-mr-xs",
                          size: "18px"
                        }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.vehicleWarningText), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5)),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_q_btn, {
                      flat: "",
                      label: "Avbryt",
                      onClick: _ctx.closeModal,
                      disable: _ctx.pending
                    }, null, 8, ["onClick", "disable"]),
                    _createVNode(_component_q_btn, {
                      label: "Skapa",
                      color: "white",
                      class: "text-red",
                      onClick: _ctx.validateAndConfirm,
                      loading: _ctx.pending,
                      disable: _ctx.disableForm
                    }, null, 8, ["onClick", "loading", "disable"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _: 1
      }),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.showConfirmModal,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showConfirmModal) = $event)),
        persistent: ""
      }, {
        default: _withCtx(() => [
          (_ctx.showConfirmModal)
            ? (_openBlock(), _createBlock(_component_VehicleWithdrawalConfirmBackInTimeModal, {
                key: 0,
                onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showConfirmModal = false)),
                onConfirm: _ctx.onSubmit
              }, null, 8, ["onConfirm"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["onHide"]))
}